// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Centralized query key definitions for item triage queries.
 * All item triage query keys should be defined here to ensure consistency.
 */

/**
 * Base query key for all item triage queries.
 * Invalidating this key will invalidate all item triage-related queries.
 */
export const itemTriageQueryKey = ['item-triage'] as const;

/**
 * Creates a query key for a triage item list with optional filters.
 *
 * @param filter - Optional filter parameters
 * @returns Query key array for the triage item list query
 */
export function triageItemListQueryKey(filter?: unknown) {
  return filter ? [...itemTriageQueryKey, filter] : itemTriageQueryKey;
}
